<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="12" class="pa-2">
                     <v-card class="pa-2">
                        <v-card-title>
                        <v-icon small left color="secondary">mdi-format-list-bulleted-type</v-icon> TRANSACTIONS  
                        <v-divider :inset="true"  class="mr-5 ml-5" vertical></v-divider>
                        <template v-if="IsADMIN">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                     <span v-on="on" ><v-icon color="secondary" @click="toggleLock()">mdi-{{LOCK_ICON}}</v-icon> </span>
                                </template>
                                <span>{{LOCK_TEXT}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                     <span v-on="on"><v-icon color="warning" @click="getTransactions()">mdi-sync</v-icon></span>
                                </template>
                                <span>Sync transactions</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                      <span v-on="on"><v-icon color="info" @ @click="sales={}, state='new', form=true" >mdi-plus-box</v-icon></span>
                                </template>
                                <span>Add Sales</span>
                            </v-tooltip>
                        </template>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-menu
                            ref="menu"
                            v-if="IsADMIN"
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="selected_date"
                                label="Select Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                single-line
                                class="mr-2"
                                hide-details
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="selected_date" no-title scrollable @input="datemenu = false, selected_fishcar={}, getTransactions()">
                            
                            </v-date-picker>
                        </v-menu>
                        <v-autocomplete
                            v-model="selected_fishcar"
                            :items="FISHCARS"
                            label="Select Fishcar"
                            item-text="name"
                            item-value="id"
                            @change="FilterTransactions()"
                            single-line
                            return-object
                            hide-details
                            
                        />
                         
                        </v-card-title>
                        <v-divider />
                        <div class="twrap">
                             <v-data-table
                                class="va-table w100"
                                dense
                                :headers="HEADERS"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="TRANSACTIONS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                         <td>
                                             <v-icon @click="sales=item, state='update', form=true" left color="warning" small v-if="!locked">mdi-pencil</v-icon>
                                            <span class="font-weight-bold">{{ item.sequence }}</span> <span class="caption">{{ item.status }}</span>
                                        </td>
                                        <td>
                                            {{item.supplier_name}}
                                        </td>
                                        <td>
                                            {{item.customer_name}} 

                                        </td>
                                        <template v-if="ALLOW_FOOTER">
                                          <td>{{ item.name }} </td>
                                          <td class="text-right">
                                          {{item.kilos}}
                                          </td>
                                          <td class="text-right">
                                          {{item.price}}
                                          </td>
                                          <td style="background: #eee;" class="text-right">
                                          <span v-if="item.payment_type=='cash'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                          </td>
                                          <td style="background: #dedede;" class="text-right">
                                          <span v-if="item.payment_type=='credit'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                          </td>
                                          <td style="background: #ccc;" class="text-right">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</td>
                                        </template>
                                         <template v-if="$session.get('role') == 'encoder'">
                                             <td>{{ item.payment_type }} </td>
                                             <td>{{ item.name }} </td>
                                              <td>{{ item.container }} </td>
                                              <td  class="text-right">{{ $money(item.price) }} </td>
                                         </template>
                                          <template v-if="$session.get('role') == 'weigher'">
                                             <td>{{ item.name }} </td>
                                              <td>{{ item.container }} </td>
                                              <td  class="text-right">{{ $money(item.kilos) }} </td>
                                         </template>
                                    </tr>
                                    </tbody>
                                     <tfoot v-if="ALLOW_FOOTER">
                                        <tr>
                                            <th># of Trans: {{TRANSACTIONS.length}}</th>
                                            <th colspan="3" class="text-right">TOTAL</th>
                                            <th class="text-right">{{$money(TOTAL_KILOS)}}</th>
                                            <th></th>
                                            <th class="text-right">{{$money(TOTAL_CASH)}}</th>
                                            <th class="text-right">{{$money(TOTAL_CREDIT)}}</th>
                                            <th class="text-right">{{$money(TOTAL_CASH + TOTAL_CREDIT)}}</th>
                                        </tr>
                                     </tfoot>
                                </template>
                                </v-data-table>
                             </div>   
                     
                    </v-card>
                    <span class="overline"  style="color: #F96332; float: right; margin-top: 2px;">Exclude Addtional Charges</span>
            </v-col>
        </v-row>
        <va-sales-form :show="form" :sales="sales" :state="state" :customers="customers" :fishcars="FISHCARS"  @DialogEvent="formEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
      mixins: [API_MIXINS],
    data: () => ({
        form: false,
        datemenu: false,
        locked: true,
        sales: {},
        search:'',
        state: 'new',
        selected_date: '',
        selected_fishcar:{},
         headers: [
        { text: '#', value: 'sequence', sortable: false},
        { text: 'Fishcar', value:'supplier_name', sortable: false},
        { text: 'Customer', value:'customer', sortable: false },
         { text: 'Kind', value:'kind', sortable: false },
        { text: 'Kilos', value:'kilos' , sortable: false, align: 'right'},
        { text: 'Price', value:'Price' , sortable: false, align: 'right'},
        { text: 'Cash', sortable: false, align: 'right'},
        { text: 'Credit', sortable: false, align: 'right'},
        { text: 'Total', sortable: false, align: 'right'},
      ],
       encoder_headers: [
        { text: '#', value: 'sequence', sortable: false},
        { text: 'Fishcar', value:'supplier_name', sortable: false},
        { text: 'Customer', value:'customer', sortable: false },
        { text: 'Payment', sortable: false},
        { text: 'Kind', value:'kind', sortable: false },
        { text: 'Container', value:'container', sortable: false },
        { text: 'Price', value:'Price' , sortable: false, align: 'right'}
      ],
      weigher_headers: [
        { text: '#', value: 'sequence', sortable: false},
        { text: 'Fishcar', value:'supplier_name', sortable: false},
        { text: 'Customer', value:'customer', sortable: false },
        { text: 'Kind', value:'kind', sortable: false },
        { text: 'Container', value:'container', sortable: false },
       { text: 'Kilos', value:'kilos' , sortable: false, align: 'right'},
      ],
        customers:[]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getTransactions()
          this.getCustomers()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      ALLOW_FOOTER(){
         if(this.$session.get('role') == 'administrator' || this.$session.get('role') == 'dispatcher' || this.$session.get('role') == 'headpatcher') {
           return true
         } 
         return false
      },
      HEADERS() {
         if(this.$session.get('role') == 'administrator' || this.$session.get('role') == 'dispatcher' || this.$session.get('role') == 'headpatcher') {
            return this.headers
         } else if(this.$session.get('role') == 'encoder'){
            return this.encoder_headers
         } else if(this.$session.get('role') == 'weigher'){
            return this.weigher_headers
         }
          return this.headers
      },
      IsADMIN(){
        if(this.$session.get('role') == 'administrator') {
            return true
        } 
        return false
      },
      LOCK_ICON(){
          if(this.locked) {
            return 'lock'
          } 
          return 'lock-open-variant'
      },
      LOCK_TEXT(){
          if(this.locked) {
            return 'Click to unlock'
          } 
          return 'Click to lock'
      },
      TRANSACTIONS() {
          return this.$store.state.todays_transactions
      },
      FISHCARS(){
       return this.$store.state.todays_fishcars
      },
      TOTAL_KILOS() {
        let total = 0
        let items = this.$store.state.todays_transactions
        for(var i= 0;i< items.length;i++) {
             total += this.$IsNum(items[i].kilos)
        }
        return total
      },
      TOTAL_CASH() {
        let total = 0
        let items = this.$store.state.todays_transactions
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "cash") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
       TOTAL_CREDIT() {
        let total = 0
        let items = this.$store.state.todays_transactions
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "credit") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
      SEQUENCE() {
          return this.$store.state.sequence
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setTodaysTransactions']),
      formEvent(data){
        console.log(data)
        this.form = false
        setTimeout(()=>{ this.getTransactions()}, 200)
      
      },
      toggleLock(){
          this.locked?this.locked=false:this.locked=true
      },
      getTransactions(){
          this.GET_TRANSACTIONS({param1: this.selected_date})
          this.GET_TODAYS_FISHCARS({param1: this.selected_date})
      },
      FilterTransactions() {
        var result = []
        let items = this.$store.state.qued_transactions
        for(var i= 0;i< items.length;i++) {
            if(items[i].supplier == this.selected_fishcar.id) {
              result.push(items[i])
            }
        }
        this.setTodaysTransactions(result)
      },
      getCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
          }).catch(e => {
           console.log(e.data)
         })
     }
    },
  }
</script>